const symbols = ['GBP/EUR', 'EUR/JPY', 'USD/CAD', 'USD/JPY', 'EUR/USD', 'AUD/USD', 'AUD/JPY', 'NZD/USD', 'NZD/JPY', 'NZD/EUR', 'USD/GBP,', 'GBP/JPY', 'GBP/AUD', 'GBP/NZD', 'GBP/USD', 'GBP/CAD', 'CAD/JPY'];
export default symbols;
